/**
 * Authorization header for the functions API: the Firebase ID token of a logged-in visitor, otherwise no header
 * (the functions treat a missing header as not logged in). An anonymous visitor does not load Firebase for it.
 * Waits until the saved session is restored: right after a page load currentUser is still null.
 */
export const useAuthHeaders = async (): Promise<Record<string, string>> => {
  if (!useUserStore().loggedIn) return {}
  const { $firebase } = useNuxtApp()
  const { auth } = await $firebase()
  await auth.authStateReady()
  const token = await auth.currentUser?.getIdToken()
  return token ? { Authorization: token } : {}
}
